/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Bad_RequestInputs */

const th_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถประมวลผลคำขอนี้ได้`)
};

const en_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That request could not be understood.`)
};

const ja_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リクエストを処理できませんでした。`)
};

const zh_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法理解此请求。`)
};

const es_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido entender esa solicitud.`)
};

const pt_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível entender essa solicitação.`)
};

const id_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan ini tidak bisa dipahami.`)
};

const fr_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette requête n’a pas pu être comprise.`)
};

const tl_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi maintindihan ang kahilingang ito.`)
};

const vi_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không hiểu được yêu cầu này.`)
};

const ko_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 요청을 이해할 수 없었습니다.`)
};

const de_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Anfrage war nicht verständlich.`)
};

const ru_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот запрос не удалось разобрать.`)
};

const tr_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu istek anlaşılamadı.`)
};

const it_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa richiesta non è comprensibile.`)
};

const pl_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się zrozumieć tego żądania.`)
};

const uk_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей запит не вдалося зрозуміти.`)
};

const hi_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह अनुरोध समझ नहीं आया।`)
};

const ar_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر فهم هذا الطلب.`)
};

const ms_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan ini tidak difahami.`)
};

const bn_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই অনুরোধটি বোঝা যায়নি।`)
};

const zh_tw2_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法理解這個請求。`)
};

const zh_hk2_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法理解這個請求。`)
};

const ur_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ درخواست سمجھ نہیں آئی۔`)
};

const fa_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این درخواست قابل فهم نبود.`)
};

const sw_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombi hili halikueleweka.`)
};

const nl_err_bad_request = /** @type {(inputs: Err_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit verzoek was niet te begrijpen.`)
};

/**
* | output |
* | --- |
* | "That request could not be understood." |
*
* @param {Err_Bad_RequestInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_bad_request = /** @type {((inputs?: Err_Bad_RequestInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Bad_RequestInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_bad_request(inputs)
	if (locale === "ja") return ja_err_bad_request(inputs)
	if (locale === "zh") return zh_err_bad_request(inputs)
	if (locale === "es") return es_err_bad_request(inputs)
	if (locale === "pt") return pt_err_bad_request(inputs)
	if (locale === "id") return id_err_bad_request(inputs)
	if (locale === "fr") return fr_err_bad_request(inputs)
	if (locale === "tl") return tl_err_bad_request(inputs)
	if (locale === "vi") return vi_err_bad_request(inputs)
	if (locale === "ko") return ko_err_bad_request(inputs)
	if (locale === "de") return de_err_bad_request(inputs)
	if (locale === "ru") return ru_err_bad_request(inputs)
	if (locale === "tr") return tr_err_bad_request(inputs)
	if (locale === "it") return it_err_bad_request(inputs)
	if (locale === "pl") return pl_err_bad_request(inputs)
	if (locale === "uk") return uk_err_bad_request(inputs)
	if (locale === "hi") return hi_err_bad_request(inputs)
	if (locale === "ar") return ar_err_bad_request(inputs)
	if (locale === "ms") return ms_err_bad_request(inputs)
	if (locale === "bn") return bn_err_bad_request(inputs)
	if (locale === "zh-TW") return zh_tw2_err_bad_request(inputs)
	if (locale === "zh-HK") return zh_hk2_err_bad_request(inputs)
	if (locale === "ur") return ur_err_bad_request(inputs)
	if (locale === "fa") return fa_err_bad_request(inputs)
	if (locale === "sw") return sw_err_bad_request(inputs)
	if (locale === "nl") return nl_err_bad_request(inputs)
	return en_err_bad_request(inputs)
});